import React from "react";

// Old components hidden - using new landing page design
// import HowWeDo from "../../container/howwedo/HowWeDo";
// import WhatWeDo from "../../container/whatwedo/WhatWeDo";
// import Hero from "../hero/Hero";
import NewLanding from "./NewLanding";

const Home = () => {
  return (
    <div>
      <NewLanding />
      {/* Old landing page components hidden */}
      {/* <Hero />
      <WhatWeDo />
      <HowWeDo /> */}
    </div>
  );
};

export default Home;
